import { Tooltip } from "./Tooltip";
import type { Plan } from "../lib/premiums";

const PLAN_TOOLTIP =
  "Each option covers a different range of shortfalls and benefits. Higher " +
  "options cover more and include additional benefits. See the benefit guide " +
  "for full details.";

interface PlanSelectorProps {
  plans: Plan[];
  value: string;
  onChange: (planId: string) => void;
}

export function PlanSelector({ plans, value, onChange }: PlanSelectorProps) {
  return (
    <div className="field">
      <label className="field__label" htmlFor="plan-select">
        Plan
        <Tooltip text={PLAN_TOOLTIP} label="About the plan options" />
      </label>
      <select
        id="plan-select"
        className="field__control select"
        value={value}
        onChange={(e) => onChange(e.target.value)}
      >
        {plans.map((plan) => (
          <option key={plan.id} value={plan.id}>
            {plan.name}
          </option>
        ))}
      </select>
    </div>
  );
}
